import formatMoney from '../../core/formatMoney';
import { selectNewFilter } from '../../sections/collection/filteredCollection';
import { removeFilterFromURL, clearAllURLFiltersAndSorting } from './filterURL';

export default class AppliedFiltersList {
  elements;
  from_search;
  prefix;

  constructor(from_search = false) {
    this.elements = {};
    this.from_search = from_search;
    this.prefix = (this.from_search) ? 'overlay-search-' : '';

    this.initListeners();
  }

  /**
   * Initialize event listeners
   * 
   * @returns {void}
   */
  initListeners = () => {
    // Clear all filters
    document.addEventListener('click', async (e) => {
      const clearAll = e.target.closest(`[data-${this.prefix}clear-all-filters]`);
      if (!clearAll) return;

      const activeOptions = document.querySelectorAll(`[data-${this.prefix}filter-options] [data-clickable-option].active`);
      const manualSort = document.querySelector(`[data-${this.prefix}sort-by] input[value="manual"]`);
      if (activeOptions.length === 0 && manualSort && manualSort.checked === true) {
        return;
      }

      document.querySelectorAll(`[data-${this.prefix}filter-options] [data-clickable-option]`).forEach(el => el.classList.remove('active'));
      document.querySelectorAll(`[data-${this.prefix}selected-filters] [data-${this.prefix}selected-filters-item]`).forEach(el => el.remove());
      document.querySelectorAll(`[data-${this.prefix}selected-filters]`).forEach(el => el.classList.remove('active'));
      document.querySelectorAll(`[data-${this.prefix}clickable-option-li]`).forEach(el => el.classList.remove('active'));

      // Sorting
      document.querySelectorAll(`[data-${this.prefix}sort-by] input[value="manual"]`).forEach(el => el.checked = true);
      document.querySelectorAll(`[data-mobile-${this.prefix}filter-sorting] input[value="manual"]`).forEach(el => el.checked = true);

      // Update the URL
      if (!this.from_search) {
        clearAllURLFiltersAndSorting();
      }

      await selectNewFilter();
    });

    // [ADA] Clear all filters with keyboard
    document.addEventListener('keypress', (e) => {
      const clearAll = e.target.closest(`[data-${this.prefix}clear-all-filters]`);
      if (!clearAll) return;
      const key = e.which || e.keyCode;
      if (key === 13 || key === 32) {
        clearAll.click();
      }
    });

    // Remove selected filter item
    document.addEventListener('click', async (e) => {
      const item = e.target.closest(`[data-${this.prefix}selected-filters-item]`);
      if (!item) return;

      const selected_value = item.getAttribute(`data-selected-filters-value`);
      const option_short_value = item.getAttribute(`data-${this.prefix}selected-filters-short-value`);
      const selected_type = item.getAttribute(`data-${this.prefix}selected-filters-type`);

      // Unselect desktop/mobile options
      document.querySelectorAll(`[data-${this.prefix}filter-options-type="${selected_type}"] [data-option-value="${selected_value}"]`).forEach(el => {
        el.classList.remove('active');
        if (el.parentElement) el.parentElement.classList.remove('active');
      });

      // Unselect all similar options
      document.querySelectorAll(`[data-${this.prefix}filter-options-type="${selected_type}"] [data-option-short-value="${option_short_value}"]`).forEach(el => {
        if (el.getAttribute('data-master-option') !== 'true') {
          el.classList.remove('active');
          if (el.parentElement) el.parentElement.classList.remove('active');
        }
      });

      // Remove the selected filter item and all related filter items
      document.querySelectorAll(`[data-${this.prefix}selected-filters-item][data-${this.prefix}selected-filters-type="${selected_type}"][data-selected-filters-value="${selected_value}"]`).forEach(el => el.remove());

      // Hide the list if no filters selected
      document.querySelectorAll(`[data-${this.prefix}selected-filters]`).forEach(selected_filters => {
        if (selected_filters.querySelectorAll(`[data-${this.prefix}selected-filters-item]`).length === 0) {
          selected_filters.classList.remove('active');
        } else {
          selected_filters.classList.add('active');
        }
      });

      // Update the URL
      if (!this.from_search) {
        removeFilterFromURL(selected_type, selected_value);
      }

      await selectNewFilter();
    });

    // [ADA] Remove selected filter item with keyboard
    document.addEventListener('keypress', (e) => {
      const item = e.target.closest(`[data-${this.prefix}selected-filters-item]`);
      if (!item) return;
      const key = e.which || e.keyCode;
      if (key === 13 || key === 32) {
        item.click();
      }
    });
  };

  /**
   * Update the list of selected filters displayed in the UI
   * 
   * @param {HTMLElement} target
   * @returns {void}
   */
  updateFiltersList = (target) => {
    // Add/remove the option to the selected filters list
    if (target.classList.contains('active')) {
      // Add the option to the selected filters list
      if (target.classList.contains('newfilter-checkbox')) {
        const option_type = target.closest(`[data-${this.prefix}filter-options]`);
        let option_value = target.getAttribute('data-option-value');
        const option_short_value = target.getAttribute(`data-option-short-value`);

        if (option_value.includes('vt::')) {
          option_value = option_value.split('::').pop();
        }

        // if (option_value.includes('USD:')) {
        //   option_value = option_value.replace(new RegExp('USD:', 'g'), '$');
        // }

        if (option_type.getAttribute(`data-${this.prefix}filter-options-type`) === 'price') {
          // option_value = `${currency_symbol}${option_value.replace(':', `-${currency_symbol}`)}`;
          const price_range_parts = option_value.split('-');
          option_value = `${formatMoney(Math.ceil(Number(price_range_parts[0]) * window.Shopify.currency.rate) * 100, theme.moneyFormat).replace('.00', '').replace(',00', '')}-${formatMoney(Math.ceil(Number(price_range_parts[1]) * window.Shopify.currency.rate) * 100, theme.moneyFormat).replace('.00', '').replace(',00', '')}`;
        }

        // Make sure to also update the code in filterState.js if editing the html below
        const filterOptionParent = target.closest('.filter-option');
        const selected_filter_item_html = `
          <div class="selected-filters__item no-themed"
            data-${this.prefix}selected-filters-item
            data-${this.prefix}selected-filters-short-value="${option_short_value}"
            data-${this.prefix}selected-filters-type="${filterOptionParent.getAttribute(`data-${this.prefix}filter-options-type`)}"
            data-selected-filters-value="${target.getAttribute('data-option-value')}"
            role="button"
            tabindex="0">
            ${option_value}
          </div>`;

        // $(`[data-${this.prefix}selected-filters-list]`).append(selected_filter_item_html);
        const selectedFiltersLists = document.querySelectorAll(`[data-${this.prefix}selected-filters-list]`);
        selectedFiltersLists.forEach((filtersList) => {
          const clearAllEl = filtersList.querySelector(`[data-${this.prefix}clear-all-filters]`);

          if (clearAllEl) {
            clearAllEl.insertAdjacentHTML('beforebegin', selected_filter_item_html);
            return;
          }

          filtersList.insertAdjacentHTML('beforeend', selected_filter_item_html);
        });
      }
    } else {
      // Remove the option from the selected filters list
      document.querySelectorAll(
        `[data-${this.prefix}selected-filters-list] [data-${this.prefix}selected-filters-item][data-selected-filters-value="${target.getAttribute('data-option-value')}"]`
      ).forEach(el => el.remove());
    }

    // Hide the list if no filters selected
    const filters_lists = document.querySelectorAll(`[data-${this.prefix}selected-filters-list]`);
    filters_lists.forEach(filters_list => {
      const filters_items = filters_list?.querySelectorAll(`[data-${this.prefix}selected-filters-item]`);
      const filters_parent = filters_list?.parentElement;

      if (filters_parent) {
        filters_parent.classList.toggle('active', filters_items?.length > 0);
      }
    });
  };
}
